module.exports = {
    API_LOCATION: "/api/", ///http://localhost:1935/  https://xdquest.skyplugins.ru/api/   /api/
    MODE: "production", // development or production mode
};
// HACK(DezLife): ВАЖНЫЙ ПАРАМЕТРЫ
